import { render, staticRenderFns } from "./cards-mixins.vue?vue&type=template&id=2bb83e9b&scoped=true"
import script from "./cards-mixins.vue?vue&type=script&lang=js"
export * from "./cards-mixins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb83e9b",
  null
  
)

export default component.exports